import React , { useState , useEffect } from 'react'
import DoCaseCard02 from './DoCaseCard02'

import axios from 'axios'


import { ApiCallGet } from '../ApiCall/ApiCall'


var arr = [

]


function DoCase03( {cardsPlus ,  theCards , theProduct , code = "" , clean , theCode}) {

    const [cards,setCards] = useState( [])


    useEffect(() => {

        if ( clean === true )
        {
            setCards( [])
        }

    },[clean])


    useEffect(() => {


        console.log( "LoadThird???????????????????? code = " + code ) ;
    
        loadThird() ;
    
    },[code])
    

    function loadThird() // Hacemos la carga del tercer nivel
    {

        console.log( "LoadThird")

        if ( code === "err")
        {
    
            console.log( "err")
            setCards( [])
            return ;
        }
    
        console.log( "DoCase01 code = " + code ) ;

        if ( code === "" )
        {
            console.log( "saliendo")
            return ;
        }
    
        ApiCallGet( "getSecondLength/?code=" + code + "&len=5"  ) // Nos vamos al cuarto nivel
        .then((response) => {
    
                console.log( "DoCase03 response = " + JSON.stringify( response )) ;
    
                arr = []
        
                for( var i = 0 ; i < response.length ; i++ )
                {
                    var obj = {} ;
                    obj.id = response[i].idsecond  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response[i].parent ;
                    obj.field3 = response[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response[i].name ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = response[i].comment ;   
                    obj.naturaleza =  response[i].naturaleza ;
                    obj.tipo = response[i].tipo ;
        
                    arr.push( obj ) ;
            
                }
        
                console.log( "arr.length = " + arr.length )
                setCards( arr ) ;
       
            } ) 
            .catch( ( err ) => {
        
                console.log( "Tenemos un error")
                console.log( err ) ;
            })
    
    
      //}
    

    } 


    function theProducto( index )
    {
        console.log( "Se selecciono el index(3) = " + cardsPlus[index].idcatcasegroup ) ;


        axios.get(  "http://localhost:3004/livefactura/getSecondLength/?code="  + cardsPlus[index].idcatcasegroup  )
        .then((response) => {
            console.log( "respuesta de  getProductos = " + JSON.stringify( response.data ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {
                    console.log( "Codigo = " + response.data[i].name ) ;

                    var obj = {} ;
                    obj.id = response.data[i].idcatcasegroup  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].value ;
                    obj.field3 = response.data[i].tagName;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = response.data[i].description ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 =  ( response.data[i].ifthen === 1 ? "Tiene ifs" : "No tiene ifs" );     
                    
                    
                    arr.push( obj ) ;
    
                }
    
                console.log( "Llamando a theCards")

                theProduct( arr ) ;
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })

    }

    function theSelected( index )
    {
        console.log( "Se selecciono el index(2) = " + index + "  length = " + cards.length ) ;

        //setSelected( arr[index] )

        console.log( "query = " + cards[index].field3 + "&len=5")


        axios.get(  "http://localhost:3004/livefactura/getCuentasAfectadas/?grupo="  + cards[index].field3 )
        .then((response) => {
            console.log( "response = " + JSON.stringify( response.data ) ) ;


            if ( response.data.length > 0 )
            {
                //setShowDrop( true ) ;
    
                var arr = [] ;
    
                for( var i = 0 ; i < response.data.length ; i++)
                {

                    console.log( "Codigo = " + response.data[i].second ) ;

                    var obj = {} ;
                    obj.id = response.data[i].second  ; // idcasesatcodigo // idcasesatcodigo
                    obj.field1 = response.data[i].parent ;
                    obj.field3 = response.data[i].second ;  
                    obj.field2 = "Marketing Director" ;
                    obj.field4 = "Hola" ; // response.data[i].comentario ;
                    obj.field5 = "Creado por Charly" ;
                    obj.field6 = "2024-02-11 17:01:02" ;   
                    obj.naturaleza =  response.data[i].naturaleza ;

                    
                    arr.push( obj ) ;
    
                }
    
                console.log( "Llamando a theCards")

                theCards( arr ) ;

                //theProducto( index )
                theCode( cards[index].field3 )

                theProduct( arr[index] ) ;
    
            }
            else{
                //setShowDrop ( false ) ;
            }
    


        })
        .catch( (err) => {
            console.log( err) ;
        })
    }


    useEffect( () => {

        console.log( "useEffect = " + JSON.stringify( cardsPlus ) ) ;

        setCards( cardsPlus ) ;

    } , [cardsPlus] )


  return (
    
        <>
            <div style={{overflowY:'auto' , overflowX :'hidden', height : '90%'}}>
                {/* <DoCaseCard01 data={arr[0]}></DoCaseCard01> */}

                {
                    cards.length > 0 && (

                        cards.map( ( elem , i ) =>
                            <DoCaseCard02 data={elem} naturaleza={elem.naturaleza} 
                             selected={theSelected} index={i}></DoCaseCard02>
                        )

                    )


                }
                {/* <DoCasePlus type={'group'}></DoCasePlus> */}

            </div>

            

        </>

  )
}

export default DoCase03

